module.exports = __webpack_public_path__ + "img/shujutoji.bbfd7873.svg";